module.exports = __webpack_public_path__ + "static/media/logo.ac64bea0.png";